import {
  EarningLossPerMonthModel,
  StocksOnHandBySector,
} from '../models/dashboard';
import { TOP_STOCK_DETAILS } from '../models/stock';

export const DUMMY_TOP_STOCK: TOP_STOCK_DETAILS[] = [
  {
    company: 'Apple Inc.',
    revenue: 2358,
    noOfTrades: 15,
    earningPercentage: 21,
  },
  {
    company: 'Microsoft Corporation',
    revenue: 1211,
    noOfTrades: 23,
    earningPercentage: 21,
  },
  {
    company: 'Amazon.com, Inc.',
    revenue: 1190,
    noOfTrades: 3,
    earningPercentage: 19,
  },
  {
    company: 'Facebook, Inc.',
    revenue: 711,
    noOfTrades: 8,
    earningPercentage: 5.8,
  },
  {
    company: 'NVIDIA Corporation',
    revenue: 212,
    noOfTrades: 8,
    earningPercentage: 3.4,
  },
];

export const DUMMY_EARNING_LOSS_PER_MONTH: EarningLossPerMonthModel[] = [
  { date: new Date('2020-12-01'), earning: 678, loss: -724 },
  { date: new Date('2021-01-01'), earning: 1235, loss: -674 },
  { date: new Date('2021-02-01'), earning: 346, loss: -262 },
  { date: new Date('2021-03-01'), earning: 541, loss: -416 },
  { date: new Date('2021-04-01'), earning: 1647, loss: -1221 },
  { date: new Date('2021-05-01'), earning: 118, loss: -235 },
];

export const  DUMMY_STOCKS_ON_HAND_BY_SECTOR: StocksOnHandBySector[] = [
  {
    sector: 'Information Technology',
    stocksOnHand: 120,
    profit: 1200,
    recentMonthlyProfit: [200, -100, 220, -50, 100, 200],
  },
  {
    sector: 'Health Care',
    stocksOnHand: 80,
    profit: 800,
    recentMonthlyProfit: [100, 120, -140, 160, -50, 200],
  },
  {
    sector: 'Financials',
    stocksOnHand: 100,
    profit: 1000,
    recentMonthlyProfit: [-160, 170, 180, -150, 180, 160],
  },
  {
    sector: 'Consumer Discretionary',
    stocksOnHand: 153,
    profit: 1530,
    recentMonthlyProfit: [230, -200, 260, -100, 260, 260],
  },
  {
    sector: 'Communication Services',
    stocksOnHand: 60,
    profit: -600,
    recentMonthlyProfit: [-100, 50, -120, 70, -90, -80],
  },
  {
    sector: 'Industrials',
    stocksOnHand: 90,
    profit: 900,
    recentMonthlyProfit: [140, -150, -160, 150, 160, -140],
  },
  {
    sector: 'Consumer Staples',
    stocksOnHand: 70,
    profit: 700,
    recentMonthlyProfit: [110, -120, 130, -120, 120, -110],
  },
  {
    sector: 'Energy',
    stocksOnHand: 50,
    profit: 500,
    recentMonthlyProfit: [-80, 90, -80, 80, -90, 80],
  },
  {
    sector: 'Utilities',
    stocksOnHand: 40,
    profit: 400,
    recentMonthlyProfit: [60, -70, 60, 70, -70, 70],
  },
  {
    sector: 'Real Estate',
    stocksOnHand: 80,
    profit: 800,
    recentMonthlyProfit: [120, -130, 140, -130, 140, 140],
  },
  {
    sector: 'Materials',
    stocksOnHand: 60,
    profit: 600,
    recentMonthlyProfit: [90, -100, -110, 100, -110, 90],
  },
];
